module.exports = __webpack_public_path__ + "757ebc67aeb6e3ca448c8bad82a0242c.svg";